import { UnavailableReportView } from "./UnavailableReportView";

export const IdvBypassedReportView = () => (
  <UnavailableReportView message="This report wasn't run because identity verification was bypassed before Boom received the applicant's date of birth and SSN." />
);
